import { gql } from '@apollo/client';

export function buildContentfulPageSlugQuery(contentfulType: string) {
  return gql`
    query GetDynamicLocales($id: String!, $locale: String!) {
    ${contentfulType}(
        id: $id
         locale: $locale
      ) {
          slug
          sys {
            locale
          }
      }
    }
  `;
}

